export default {
  path: 'payslip',
  name: '发薪单管理',
  icon: 'ConstructionSiteEquipmentFilled',
  accessKey: '/payslip',
  routes: [
    // 发薪单相关页面
    {
      path: 'list',
      component: '@/pages/payslip/list',
      name: '一键发薪',
      accessKey: '/payslip/list',
    },
    {
      path: 'list/detail',
      component: '@/pages/payslip/list/detail',
      name: '详情',
      hideInMenu: true,
      accessKey: '/payslip/list',
      selectedKey: '/payslip/list',
    },
    {
      path: 'list/edit',
      component: '@/pages/payslip/list/edit',
      name: '编辑',
      hideInMenu: true,
      accessKey: '/payslip/list',
      selectedKey: '/payslip/list',
    },
    // 发薪单审批相关页面
    {
      path: 'approval',
      component: '@/pages/payslip/approval',
      name: '发薪单审批',
      accessKey: '/payslip/approval',
    },
    {
      path: 'approval/detail',
      component: '@/pages/payslip/approval/detail',
      name: '详情',
      hideInMenu: true,
      accessKey: '/payslip/approval',
      selectedKey: '/payslip/approval',
    },
    // 项目管理相关页面
    {
      path: 'project',
      component: '@/pages/payslip/project',
      name: '项目管理',
      accessKey: '/payslip/project',
    },
  ],
};
